import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutGrid } from 'lucide-react';
import { cn } from '../lib/utils';
import { navGroups } from './Sidebar/navConfig';

const dockItems = [
  { label: 'Home', path: '/', icon: LayoutGrid },
  { label: 'PLM', ...navGroups[0].items[0] },
  { label: 'PDM', ...navGroups[1].items[1] },
  { label: 'ERP', ...navGroups[3].items[0] },
  { label: 'ECM', ...navGroups[2].items[0] },
];

export function MobileDock() {
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-40 px-4 md:hidden">
      <div className="pointer-events-auto mx-auto max-w-md rounded-[28px] border border-border bg-surface-raised/88 backdrop-blur-2xl shadow-panel">
        <div className="grid grid-cols-5 gap-1 p-2">
          {dockItems.map((item) => {
            const Icon = item.icon;

            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  cn(
                    'flex flex-col items-center justify-center gap-1 rounded-[20px] px-2 py-2.5 transition-all duration-200',
                    isActive
                      ? 'bg-primary-500/12 text-primary-600 shadow-subtle'
                      : 'text-content-secondary hover:bg-surface-overlay/80 hover:text-content'
                  )
                }
              >
                <Icon className="h-4 w-4" />
                <span className="text-[11px] font-semibold tracking-[-0.02em]">{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </div>
  );
}